import React from "react";
import { keyframes } from "@mui/material/styles";
import MDBox from "components/MDBox";
import { gpsStatusBadgeColor } from "utils/constant";

const pulse = keyframes`
  0% { transform: scale(1); opacity: 0.55; }
  100% { transform: scale(2.4); opacity: 0; }
`;

// Same palette mapping as the GPS status badge; stale data is always red.
export const vehicleColorKey = (vehicle, live) =>
  live ? gpsStatusBadgeColor(vehicle?.motionLabel) : "error";

// Matches TankLabel in tablet-device/TabletMap.js.
const labelSx = {
  mb: 0.75,
  px: 1,
  py: 0.25,
  borderRadius: "6px",
  backgroundColor: "rgba(15, 23, 42, 0.85)",
  color: "#fff",
  fontSize: "12px",
  fontWeight: 700,
  lineHeight: 1.4,
  whiteSpace: "nowrap",
  boxShadow: "0 1px 4px rgba(0,0,0,0.4)",
  pointerEvents: "none",
};

export default function LinkedVehicleMarker({ vehicle, live, selected }) {
  const colorKey = vehicleColorKey(vehicle, live);
  const moving = live && vehicle.motion === "moving";
  const label = [vehicle.name, moving && vehicle.speed != null ? `${Math.round(vehicle.speed)} mph` : null]
    .filter(Boolean)
    .join(" · ");

  return (
    <MDBox
      display="flex"
      flexDirection="column"
      alignItems="center"
      sx={{ cursor: "pointer", opacity: selected ? 1 : 0.75, transition: "opacity 150ms ease" }}
    >
      <MDBox sx={labelSx}>{label}</MDBox>
      <MDBox position="relative" width={34} height={34}>
        {moving && (
          <MDBox
            sx={({ palette }) => ({
              position: "absolute",
              inset: 0,
              borderRadius: "50%",
              backgroundColor: palette[colorKey].main,
              animation: `${pulse} 1.8s ease-out infinite`,
              pointerEvents: "none",
            })}
          />
        )}
        {moving && (
          <MDBox
            sx={{
              position: "absolute",
              inset: -11,
              transform: `rotate(${vehicle.heading}deg)`,
              transition: "transform 1s ease-out",
              pointerEvents: "none",
            }}
          >
            <MDBox
              sx={({ palette }) => ({
                position: "absolute",
                top: 0,
                left: "50%",
                transform: "translateX(-50%)",
                width: 0,
                height: 0,
                borderLeft: "6px solid transparent",
                borderRight: "6px solid transparent",
                borderBottom: `9px solid ${palette[colorKey].main}`,
                filter: "drop-shadow(0 1px 1px rgba(0,0,0,0.5))",
              })}
            />
          </MDBox>
        )}
        <MDBox
          sx={({ palette }) => ({
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "50%",
            backgroundColor: palette[colorKey].main,
            border: `3px solid ${palette.white.main}`,
            color: palette.white.main,
            boxShadow: selected
              ? `0 0 0 3px ${palette.info.main}, 0 2px 6px rgba(0,0,0,0.45)`
              : "0 2px 6px rgba(0,0,0,0.45)",
          })}
        >
          <i className="fa-solid fa-truck" style={{ fontSize: 13 }} />
        </MDBox>
      </MDBox>
    </MDBox>
  );
}
